<template>
  <section class="hero has-background-white-ter is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-5-tablet is-4-desktop is-3-widescreen">
            <div class="box" v-on:keyup.enter="login">
              <h1 class="title has-text-primary has-text-centered">Sortdesk</h1>
              <b-field label="Benutzername">
                <b-input v-model="username"></b-input>
              </b-field>
              <b-field label="Passwort">
                <b-input type="password" v-model="password" password-reveal>
                </b-input>
              </b-field>
              <br />
              <template v-if="wrongCredentials"
                ><p class="has-text-danger has-text-centered">
                  Please try again
                </p>
                <br
              /></template>
              <b-button type="is-primary" expanded @click="login"
                >Einloggen</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { login } from "@/auth";

export default {
  data() {
    return {
      username: null,
      password: null,
      wrongCredentials: false
    };
  },
  methods: {
    login() {
      const loggedIn = login(this.username, this.password);
      if (loggedIn) {
        this.$router.go();
      } else {
        this.wrongCredentials = true;
        this.username = null;
        this.password = null;
      }
    }
  }
};
</script>

<style></style>
